<template>
  <div id="contact">
          <h1 class="section_title text-center">Stay In Touch</h1>
          <div class="contact-us">
            <p class="mb-2">
              <b>Location</b>: Kitisuru off Kinanda Road
            </p>
            <p class="mb-2">
              <b>Phone</b>: 0705-927-516
            </p>
            <p class="mb-2">
              <b>Email</b>: citychurchchrisco@gmail.com
            </p>
            <p>
              <a
                href="https://www.facebook.com/Chrisco-City-Church-109105327395549/"
                target="_blank"
                class="mr-2"
              >
                <img src="/assets/img/facebook.svg" />
              </a>
              <a href="https://www.youtube.com/channel/UCjflH0plI24pX7hJp0D-RUw" target="_blank">
                <img src="/assets/img/youtube.png" />
              </a>
            </p>
          </div>
          <div class="contact-box text-center mt-4">
            <!-- Contact Form -->
            <form id="contact-form">
              <div class="row">
                <div class="col-lg-12">
                  <p v-if="errors.length" class="form-message">
              <b>Please correct the following error(s):</b>
              <ul>
                <li v-for="(error, index) in errors" :key="index" class="text-danger">
                   * {{ error }}
                </li>
            </ul>
            </p>
                </div>
              </div>
              <div class="row no-gutters">
                <div class="col-6">
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      name="name"
                      placeholder="Name"
                      required="required"
                      v-model="name"
                    />
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-group">
                    <input
                      type="email"
                      class="form-control"
                      name="email"
                      placeholder="Email"
                      required="required"
                      v-model="email"
                    />
                  </div>
                </div>
              </div>
              <div class="row no-gutters">
                <div class="col-12">
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      name="subject"
                      placeholder="Subject"
                      required="required"
                      v-model="subject"
                    />
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <textarea
                      class="form-control"
                      name="message"
                      placeholder="Message"
                      required="required"
                      v-model="message"
                    ></textarea>
                  </div>
                </div>
                <div class="col-12">
                  <button v-if="sending" type="button" class="custom_send_btn">Please wait ...</button>
                  <button
                    v-else
                    type="button"
                    class="custom_send_btn"
                    @click.prevent="submitForm"
                  >Send Message</button>
                </div>
              </div>
            </form>
          </div>
        </div>
</template>

<script>
import axios from 'axios'

export default {
  name: "contact-form",
  data() {
    return {
      name: "",
      email: "",
      subject: "",
      message: "",
      sending: false,
      errors: []
    };
  },
  methods: {
    async submitForm() {
      this.sending = true;
      this.errors = [];

      if (this.name && this.email && this.message && this.subject) {
        try {
          let { name, email, message, subject } = this;
          let res = await axios.post(
            "https://chrisco-api.herokuapp.com/email_transport",
            {
              name,
              email,
              message,
              subject
            }
          );
          console.log(res.data);
          // alert(res.data)
          alert("Message sent");
        } catch (error) {
          // alert(error)
          console.log(error);
          alert("Could not send message");
        } finally {
          this.name = "";
          this.subject = "";
          this.message = "";
          this.email = "";
        }
        this.sending = false;
        return;
      }

      if (!this.name) {
        this.errors.push("Name required.");
      }
      if (!this.email) {
        this.errors.push("Email required.");
      }
      if (!this.messsage) {
        this.errors.push("Message required.");
      }
      if (!this.subject) {
        this.errors.push("Subject required.");
      }
      this.sending = false;
    }
  }
};
</script>

<style lang='scss' scoped>
@import "../assets/css/variables.scss";
@import "../assets/css/locate.scss";

.section_title {
  margin-bottom: 20px;
}

 </style>